document.addEventListener('DOMContentLoaded', function() {
    // Función para inicializar/actualizar el comportamiento de tabs
    function initFooterTabs() {
        const footerBlocks = document.querySelectorAll('.footer-block');
        
        footerBlocks.forEach(block => {
            const heading = block.querySelector('.footer-block__heading');
            const content = block.querySelector('.footer-block__details-content');
            
            // Solo aplicar a bloques que tengan h2 y ul
            if (heading && content && content.tagName === 'UL') {
                // Verificar si estamos en móvil (<= 680px)
                if (window.innerWidth <= 680) {
                    // Si ya fue inicializado, no hacer nada
                    if (heading.classList.contains('footer-tab-initialized')) {
                        return;
                    }
                    
                    // Marcar como inicializado
                    heading.classList.add('footer-tab-initialized');
                    
                    // Añadir clase para identificar que es un tab
                    heading.classList.add('footer-tab-heading');
                    content.classList.add('footer-tab-content');
                    
                    // Ocultar contenido inicialmente
                    content.style.display = 'none';
                    
                    // Añadir indicador visual (flecha)
                    const arrow = document.createElement('span');
                    arrow.className = 'footer-tab-arrow';
                    arrow.innerHTML = '';
                    heading.appendChild(arrow);
                    
                    // Añadir evento click
                    heading.addEventListener('click', function() {
                        const isHidden = content.style.display === 'none';
                        
                        if (isHidden) {
                            content.style.display = 'block';
                            arrow.style.transform = 'rotate(220deg)';
                        } else {
                            content.style.display = 'none';
                            arrow.style.transform = 'rotate(40deg)';
                        }
                    });
                    
                } else {
                    // En desktop, remover estilos y comportamientos
                    if (heading.classList.contains('footer-tab-initialized')) {
                        heading.classList.remove('footer-tab-initialized', 'footer-tab-heading');
                        content.classList.remove('footer-tab-content');
                        content.style.display = '';
                        
                        // Remover flecha si existe
                        const arrow = heading.querySelector('.footer-tab-arrow');
                        if (arrow) {
                            arrow.remove();
                        }
                        
                        // Remover event listener
                        heading.replaceWith(heading.cloneNode(true));
                    }
                }
            }
        });
    }
    
    // Ejecutar al cargar
    initFooterTabs();
    
    // Ejecutar al cambiar tamaño de ventana
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initFooterTabs, 250);
    });
});